import {Injectable} from '@angular/core';
import {LOCALSTORAGE_KEY_LIST_HELP, OPTION_TYPE} from '../../defines/client.const';


export enum LIST_HELP_FLAG {
  ABOUT,
  LARGE_FONT,
  AUTO_PLAY,
  SEARCH,
  START_ANIM,
  JASO_BTN,
  HISTORY_BTN,
}

export enum LIST_HELP_TYPE {
  HELP,
  OPTION,
}

export type LIST_HELP_ITEM = {
  flag: LIST_HELP_FLAG,
  type: LIST_HELP_TYPE;
  content: number | OPTION_TYPE;
  check: (type: unknown, count: number) => boolean;
  priority: number;
};

const ONLY_ONE = (type: unknown, count: number) => {
  return count < 1;
};

const listHelpItems: Array<LIST_HELP_ITEM> = [
  // {
  //   flag: LIST_HELP_FLAG.ABOUT,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 1,
  //   check: (type: unknown, count: number) => true,
  //   priority: 100,  // 무조건적, 최우선으로 출력
  // },
  {
    flag: LIST_HELP_FLAG.LARGE_FONT,
    type: LIST_HELP_TYPE.OPTION,
    content: OPTION_TYPE.LARGE_MODE,
    check: (type: unknown, count: number) => {
      return count < 2;
    },
    priority: 1,
  },
  {
    flag: LIST_HELP_FLAG.AUTO_PLAY,
    type: LIST_HELP_TYPE.OPTION,
    content: OPTION_TYPE.AUTO_PLAY,
    check: ONLY_ONE,
    priority: 1,
  },
  // {
  //   flag: LIST_HELP_FLAG.SEARCH,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 5,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
  {
    flag: LIST_HELP_FLAG.START_ANIM,
    type: LIST_HELP_TYPE.OPTION,
    content: OPTION_TYPE.START_ANIM,
    check: ONLY_ONE,
    priority: 1,
  },
  // {
  //   flag: LIST_HELP_FLAG.JASO_BTN,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 7,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
  // {
  //   flag: LIST_HELP_FLAG.HISTORY_BTN,
  //   type: LIST_HELP_TYPE.HELP,
  //   content: 8,
  //   check: ONLY_ONE,
  //   priority: 1,
  // },
];



@Injectable({
  providedIn: 'root'
})
export class ListHelpService {
  private flags: Set<number> = null;

  constructor() {
    this.load();
  }

  public reset(): void {
    this.flags = new Set<number>();
    this.save();
  }

  GetListHelp(type: unknown): Array<LIST_HELP_ITEM> {
    let count = 0;
    const listHelp = listHelpItems.filter(item => {
      const ret = !this.flags.has(item.flag) && item.check(null, count);
      if (ret) {
        ++count;
      }
      return ret;
    }).sort((a, b) => b.priority - a.priority);

    if (listHelp.length === 0) {
      this.reset();
    }

    return listHelp;
  }

  public SetFlag(type: LIST_HELP_FLAG): void {
    this.flags.add(type);
    this.save();
    // console.log('SetFlag()', type, this.flags);
  }

  toJSON(): any {
    return {
      flags: Array.from(this.flags),
    };
  }

  public load(): void {
    const txtOptions = localStorage.getItem(LOCALSTORAGE_KEY_LIST_HELP);
    const json = txtOptions ? JSON.parse(txtOptions) : null;

    this.flags = new Set<number>(json && 'flags' in json ? json.flags : []);

    console.log('ListHelpService::load()', this);
  }

  public save(): void {
    localStorage.setItem(LOCALSTORAGE_KEY_LIST_HELP, JSON.stringify(this));
  }
}
